/** @flow */

import type { OvmTokensActions } from 'app/core/types/StoreResourcesCustomActions'
import type { StoreResourceDef } from 'app/core/types'

export const ovmTokens: StoreResourceDef<OvmTokensActions<>> = {
  resourceType: 'ovmTokens',
}
